import React from 'react';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { ReactQueryProvider } from '@/providers/react-query-provider';
import { ToastProvider } from '@/providers/toast-provider';
import { AuthContextProvider } from '@/hooks/use-auth';
import { NotificationsProvider } from '@/features/shared/notifications/provider';
import { PopUpConfirmationProvider } from '@/features/shared/pop-up-confirmation/provider';
import {
  AdminSideNavigation,
  AdminRoutes,
} from '@/features/admin/navigation/containers/admin-side-navigation';
import { BroadcastMessagesList } from '@/features/admin/community_broadcast_messages/components/broadcast-messages-list';

const BroadcastMessagesScreen = () => {
  return (
    <ReactQueryProvider>
      <ToastProvider />
      <AuthContextProvider>
        <NotificationsProvider>
          <PopUpConfirmationProvider>
            <ReactQueryDevtools initialIsOpen={false} />
            <div className="flex h-screen w-screen">
              <AdminSideNavigation tabToSet={AdminRoutes.CommunityBroadcastMessages} />
              <BroadcastMessagesList />
            </div>
          </PopUpConfirmationProvider>
        </NotificationsProvider>
      </AuthContextProvider>
    </ReactQueryProvider>
  );
};

export { BroadcastMessagesScreen };
